import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { validatorsOfType } from './build-validators';
export class DynamicFormControl extends FormControl {
  constructor(fieldDefinition) {
    super(fieldDefinition.data instanceof Observable ? null : fieldDefinition.data, validatorsOfType(fieldDefinition.validationFunctions, 'sync'), validatorsOfType(fieldDefinition.validationFunctions, 'async'));
    this.fieldDefinition = fieldDefinition;
    this.controlName = fieldDefinition.name;
    this.validationDefinitions = fieldDefinition.validationDefinitions;
  }
}